import React from "react";
import MainPageView from "./MainPageView";
import { MainPageViewModel } from "./MainPageViewModel";

interface Props {
  tag: string;
  name: string;
  loggedState: number;
  loggedID: string;
  token: string;
  setloggedState: React.Dispatch<React.SetStateAction<number>>;
  testAlarms: number;
  agbStatus: number;
  dsgvoStatus: number;
  useCondStatus: number;
  alarmMonitorURL: string;
}

const MainPage: React.FC<Props> = (props) => {
  const vm = MainPageViewModel({
    loggedID: props.loggedID,
    testAlarms: props.testAlarms,
    tag: props.tag,
    setloggedState: props.setloggedState,
  });

  return (
    <MainPageView
      name={props.name}
      tag={props.tag}
      token={props.token}
      loggedID={props.loggedID}
      loggedState={props.loggedState}
      testAlarms={props.testAlarms} // <-- Wichtig: Hier durchreichen
      agbStatus={props.agbStatus}
      dsgvoStatus={props.dsgvoStatus}
      useCondStatus={props.useCondStatus}
      state={vm.state}
      actions={vm.actions}
      onOpenSettings={vm.actions.openSettings}
      onSend={vm.actions.sendAlarm}
    />
  );
};

export default MainPage;